import React, { useEffect, useState, useRef } from 'react'
import '.././App.css';
import Swal from 'sweetalert2';
import { auth, db } from '../firebase';
import { collection, addDoc, Timestamp, query, orderBy, onSnapshot, getDoc, getDocs, deleteDoc, doc, setDoc, getAggregateFromServer, where, sum } from 'firebase/firestore'
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';

export default function DealerAccount() {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  });

  const printRef = useRef();

  const [userData, setUserData] = useState();
  const [dealers, setdealers] = useState([]);
  const [payhistory, setpayhistory] = useState([]);

  const [searchText, setsearchText] = useState("");
  const [name, setname] = useState("");
  const [mobile, setmobile] = useState("");
  const [address, setaddress] = useState("");

  const [grandtotal, setgrandtotal] = useState("0");
  const [previuspaid, setpreviuspaid] = useState("0");
  const [currentpaid, setcurrentpaid] = useState("0");
  const [remaining, setremaining] = useState("0");
  const [remaining1, setremaining1] = useState("0");
  const [paytype, setpaytype] = useState("Cash");
  const [paidDate, setpaidDate] = useState("Cash");
  const [bankutr, setbankutr] = useState("");

  const [updocid, setupdocid] = useState("");

  useEffect(() => {
    if (searchText === '') {
      fetchData1()
      const today = new Date();
      const formattedDate = today.toISOString().split('T')[0];
      setpaidDate(formattedDate);
    } else {
      fetchData2()
    }
  }, [searchText]);



  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      setUserData(user);
    });
  });

  const fetchData1 = async () => {
    try {
      // Fetch all dealers at once
      const q1 = query(collection(db, 'dealers'), orderBy("created", "desc"));
      const querySnapshot1 = await getDocs(q1);
      const dealerIds = querySnapshot1.docs.map((doc) => doc.id);

      // Batch fetch dealer account history and purchases for all dealers
      const [dealerAccountHistories, purchases] = await Promise.all([
        fetchDealerAccountHistories(dealerIds),
        fetchPurchases(dealerIds),
      ]);

      // Combine data for all dealers
      const combinedData = querySnapshot1.docs.map((doc1) => {
        const grandtotal = purchases[doc1.id] || 0;
        const paidamount = dealerAccountHistories[doc1.id] || 0;
        const remaining = parseFloat(grandtotal) - parseFloat(paidamount);

        return {
          id: doc1.id,
          data: doc1.data(),
          totalamount: grandtotal.toFixed(2),
          paidamount: paidamount.toFixed(2),
          remaining: remaining.toFixed(2),
        };
      });

      setdealers(combinedData);
    } catch (error) {
      Toast.fire({
        icon: "error",
        title: error.message,
      });
    }
  };

  // Helper function to batch fetch dealer account histories
  const fetchDealerAccountHistories = async (dealerIds) => {
    const histories = {};
    const q = query(collection(db, 'dealeracchistory'), where('dealerId', 'in', dealerIds));
    const snapshot = await getDocs(q);
    snapshot.forEach((doc) => {
      const data = doc.data();
      if (!histories[data.dealerId]) histories[data.dealerId] = 0;
      histories[data.dealerId] += parseFloat(data.paidamount);
    });
    return histories;
  };

  // Helper function to batch fetch purchases
  const fetchPurchases = async (dealerIds) => {
    const purchases = {};
    const q = query(collection(db, 'purchases'), where('dealerId', 'in', dealerIds));
    const snapshot = await getDocs(q);
    snapshot.forEach((doc) => {
      const data = doc.data();
      if (!purchases[data.dealerId]) purchases[data.dealerId] = 0;
      purchases[data.dealerId] += parseFloat(data.grandtotal);
    });
    return purchases;
  };


  const fetchData2 = async () => {
    try {
      const filteredData = dealers.filter((item) =>
        item.data.name.toUpperCase().includes(searchText.toUpperCase())
      );
      setdealers(filteredData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }


  const handleReply = (docid, totalamount, padiamount, remaining) => {
    setupdocid(docid);
    setgrandtotal(totalamount);
    setpreviuspaid(padiamount);
    setremaining(remaining);
    setremaining1(remaining);

  }

  const handleUpdate = async () => {
    await addDoc(collection(db, 'dealeracchistory'), {
      dealerId: updocid,
      purchaseNo: "",
      purchasedocid: "",
      paiddate: paidDate,
      grandtotal: "",
      paidamount: parseFloat(currentpaid),
      remaining: remaining,
      paytype: paytype,
      bankutr: bankutr,
      status: 'Active',
      note: 'Paid from the dealer amount',
      uid: userData.uid,
      created: Timestamp.now()
    });

    setcurrentpaid(0);
    Toast.fire({
      icon: "success",
      title: 'Dealer payment updated successfully!!'
    });

    fetchData1();
  }


  const finaltotal = () => {
    let remainingnew = parseFloat(remaining1) - parseFloat(currentpaid);
    if (remainingnew < 0) {
      Toast.fire({ icon: "error", title: 'Remaining should not be less than 0' });
      setcurrentpaid("");
      setremaining(remaining1);
      return;
    }
    if (currentpaid === '') {
      setremaining(remaining1);
    } else {
      setremaining(remainingnew);
    }
  }

  const handleView = (docid, name, mobile, address) => {
    setname(name);
    setmobile(mobile);
    setaddress(address);

    const q = query(collection(db, 'dealeracchistory'), where("dealerId", "==", docid), orderBy('paiddate', 'desc'));
    onSnapshot(q, (querySnapshot2) => {
      setpayhistory(querySnapshot2.docs.map(doc => ({
        id: doc.id,
        data: doc.data(),
      })));
    });
  }

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  })

  const handleDelete = async (docid) => {
    const taskDocRef = doc(db, 'dealeracchistory', docid)
    await deleteDoc(taskDocRef)
    Toast.fire({
      icon: "success",
      title: 'Dealer Payment Entry Deleted Successfully!!'
    });
    fetchData1();
    // const q = query(collection(db, 'dealeracchistory'), where("dealerId", "==", docid), orderBy('paiddate', 'desc'));
    // onSnapshot(q, (querySnapshot2) => {
    //   setpayhistory(querySnapshot2.docs.map(doc => ({
    //     id: doc.id,
    //     data: doc.data(),
    //   })));
    // });
  }

  return (
    <div>
      <div className="content-wrapper">
        <br />
        <section className="content">
          <div className="container-fluid">
            <button className="btn btn-secondary " style={{ float: "right" }} >|| Dealer  Account||</button><br /><br />
            <div className="card card-primary card-outline ex1">
              <div className=" p-1">
                &nbsp;&nbsp;<input type="search" value={searchText} onChange={(e) => setsearchText(e.target.value)}
                  className='form-control col-sm-4' placeholder='Type here......' />&nbsp;
              </div>
              <div className="card-body table-responsive p-0" >
                <table className="table table-bordered table-hover table-striped table-head-fixed">
                  <thead>
                    <tr>
                      <th>Sr No</th>
                      <th>Dealer Name</th>
                      <th>Mobile</th>
                      <th>Address</th>
                      <th>Total Amount</th>
                      <th>Paid </th>
                      <th>Remaining</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      dealers.map((item, num = 1) =>
                        <tr key={num + 1}>
                          <td width="80">{num + 1}</td>
                          <td>{item.data.name}</td>
                          <td>{item.data.mobile}</td>
                          <td>{item.data.address}</td>
                          <td>{parseFloat(item.totalamount).toFixed(2)}</td>
                          <td>{parseFloat(item.paidamount).toFixed(2)}</td>
                          <td>{parseFloat(item.remaining).toFixed(2)}</td>
                          <td>
                            <a onClick={() => handleReply(item.id, item.totalamount, item.paidamount, item.remaining)} href='#0' data-toggle="modal" data-target="#text-modal1" className="btn btn-sm btn-info" > <i className="fa fa-reply"></i></a>&nbsp;
                            <a onClick={() => handleView(item.id, item.data.name, item.data.mobile, item.data.address)} className="btn btn-sm btn-success" href='#0' data-toggle="modal" data-target="#text-modal2"> <i className="fa fa-eye"></i></a>&nbsp;
                          </td>
                        </tr>
                      )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* ============================================= modal start ================================================= */}

      <div className="modal fade" id="text-modal1">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Pay Dealer Amount</h4>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-sm-4">
                  <label> Total Amount</label>
                  <input type="text" className='form-control' style={{ height: 35, fontSize: 14 }} readOnly value={grandtotal} />
                </div>
                <div className="col-sm-4">
                  <label>Previus Paid</label>
                  <input type="text" className='form-control' style={{ height: 35, fontSize: 14 }} value={previuspaid} readOnly />
                </div>
                <div className="col-sm-4">
                  <label>Current Paid</label>
                  <input type="text" className='form-control' style={{ height: 35, fontSize: 14 }} onKeyUp={() => finaltotal()} value={currentpaid} onChange={(e) => setcurrentpaid(e.target.value)} placeholder='Enter Paid Amount' />
                </div>
                <div className="col-sm-4 mt-2">
                  <label>Remaining</label>
                  <input type="text" className='form-control' style={{ height: 35, fontSize: 14 }} value={remaining} readOnly />
                </div>
                <div className="col-sm-4 mt-2">
                  <label>Pay Type</label>
                  <select className='form-control' style={{ height: 35, fontSize: 14 }} value={paytype} onChange={(e) => setpaytype(e.target.value)}>
                    <option value="Cash">Cash</option>
                    <option value="Bank">Bank</option>
                    <option value="RTGS">RTGS</option>
                    <option value="Online Pay">Online Pay</option>
                  </select>
                </div>
                <div className="col-sm-4 mt-2">
                  <label>Paid Date</label>
                  <input type="date" className="form-control" style={{ height: 35, fontSize: 14 }} value={paidDate} onChange={(e) => setpaidDate(e.target.value)} />
                </div>
                <div className="col-sm-4 mt-2">
                  <label>Bank UTR No</label>
                  <input type="text" className="form-control" style={{ height: 35, fontSize: 14 }} value={bankutr} onChange={(e) => setbankutr(e.target.value)} />
                </div>
              </div><br />
            </div>
            <div className="modal-footer justify-content-between">
              <button type="button" onClick={() => handleUpdate()} className="btn btn-primary" data-dismiss="modal">Add Payment </button>
              <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>


      <div className="modal fade" id="text-modal2">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Dealer Payment History</h4>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span></button>
            </div>
            <div className="modal-body" ref={printRef}>
              <div className='row border'>
                <div className='col-sm-6'>
                  <label>Dealer Name :  </label> {name}
                </div>
                <div className='col-sm-6'>
                  <label>Dealer Mobile : </label> {mobile}
                </div>
                <div className='col-sm-6'>
                  <label>Dealer Address :  </label> {address}
                </div>
              </div>
              <table className='customers' style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th><label>Date</label></th>
                    <th><label>Total Amount</label></th>
                    <th><label>Paid Amount</label></th>
                    <th><label>Remaining</label></th>
                    <th><label>Pay Type</label></th>
                    <th><label>Note</label></th>
                    <th><label>Bank UTR No</label></th>
                    <th><label>Action</label></th>
                  </tr>
                </thead>
                <tbody>

                  {
                    payhistory.map((item, index) =>
                      <tr key={index}>
                        <td>{moment(item.data.paiddate).format("DD-MM-YYYY")}</td>
                        <td>{item.data.grandtotal}</td>
                        <td>{item.data.paidamount}</td>
                        <td>{item.data.remaining}</td>
                        <td>{item.data.paytype}</td>
                        <td>{item.data.note}</td>
                        <td>{item.data.bankutr}</td>
                        <td>
                          <a onClick={() => handleDelete(item.id)} className="btn btn-sm btn-danger" href='#0' > <i className="fa fa-trash"></i></a>
                        </td>
                      </tr>

                    )}
                </tbody>
              </table>
            </div>
            <div className="modal-footer justify-content-between">
              <button type="button" className="btn btn-info" onClick={handlePrint}>Print</button>
              <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
